import { LessonType } from "db/enums"

export default function getLessonTypeTitle(type: LessonType) {
  return type === "LESSON" ? "Les" : "Lied"
}
